// Defaults mirror REFRESH_REPORTS_DEFAULTS in config/settingsConstants/googleAdsBridgeConstants.js (server).
// CRA cannot import a server file: change both together.
export const CRON_CONFIG_FORM_KEY = 'config_fields'

export const CRON_CONFIG_SCHEMAS = {
   refreshReports: [
      { key: 'tuneDays', label: 'Tune days', type: 'number', min: 1, defaultValue: 2,
        helperText: 'Days of Tune data pulled on each run' },
      { key: 'reportIds', label: 'Reports to refresh', type: 'reports', defaultValue: [],
        helperText: 'Empty list: the cron pulls nothing' },
   ],
}
